import Image from 'next/image';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { IC_ARROW, SPECIAL_OFFER, TICK, TAG_BROWN, TAG_GREEN, BUNDLEOFFER, BUNDLE_DEAL_PDP_UPDATED } from '../../Assets/images';
import { RightSideBarStyled } from './RightSideBarStyled';
import VerificationStatus from '../VerificationStatus/VerificationStatus';
import { removeDecimalPoints } from '../../Utility/common-utils';
import { isRTL } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../i18n';

const RightSideBar = (props) => {
  const [show, setShow] = useState(true);
  const [currentLang, setCurrentLanguage] = useState('');

  useEffect(() => {
    if(window !== 'undefined') {
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);
  
  const secondaryButtonClicked = () => {
    props?.secondaryButtonClicked();
  };
  const primaryButtonClicked = () => {
    props?.primaryButtonClicked();
  };

  const {
    orderType,
    formattedDate,
    formattedTime,
    deliveryTitle,
    isPromotionCart,
    messagePrefix,
    upsellingprice,
    upsellingqty,
    fbtSkuId,
    cartFillers,
    fbt_isStock,
    pdp_price,
    pdp_qty,
    fbt_disabled,
    fbtshow3,
    showUpselling,
    showCTA,
    modalSubTitle,
  } = props;
  return (
    <RightSideBarStyled
      className="modalStyled"
      isPromotionCart={props?.isPromotionCart}
      style={{ display: show ? 'block' : 'none' }}
    >
      <Modal
        data-testid="modal"
        show={show}
        backdropClassName="modalBackDropStyled"
        dialogClassName={`rightBarDialogStyled ${currentLang && isRTL(currentLang) ? 'rtl' : ''}`}
        onHide={() => {
          if (props.isHide) {
            setShow(false);
            {props?.isBundleSideBar && props?.setafterBundle(true)} ;
          }
          props?.handleClose(false);
        }}
        backdrop="static"
        keyboard={false}
        size={props?.size}
        className={props?.customClass}
      >
        {orderType === 'Prescription' ? (
          <Modal.Header closeButton={props?.closeButton}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '75%' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  fontSize: '13px',
                  fontWeight: '600',
                }}
              >
                <div style={{ marginRight: '10px' }}>{formattedDate}</div>
                <div
                  style={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    background: '#e3e9ef',
                    marginRight: '8px',
                  }}
                ></div>
                <div>{formattedTime}</div>
              </div>
              <VerificationStatus
                classStatus="status"
                label={deliveryTitle}
                status={deliveryTitle === 'Out for Delivery' ? 'outForDelivery' : deliveryTitle}
                withoutIcon
                isPopup
              />
            </div>
          </Modal.Header>
        ) : (
          props?.modalTitle && (
            <Modal.Header
              closeButton={props?.closeButton}
              className={`${props.isPromotionCart && showUpselling ? 'promotion' : ''} ${
                props?.isBundleSideBar ? 'bundleside' : ''
              }   `}
            >
              <Modal.Title className={`${props.isPromotionCart && !showUpselling ? 'promotionCart' : ''} `}>
                {props?.isBundleSideBar && <Image src={BUNDLE_DEAL_PDP_UPDATED} width={98} height={24} />}
                {props?.isBackEnabled && (
                  <Button className="d-inline-block p-0" onClick={props?.backButtonClicked} variant="link">
                    <Image
                      src={IC_ARROW}
                      width={props?.isPromotionCart ? '2px' : props?.arrowIconWidth}
                      height={props?.arrowIconHeight}
                      alt="Back Arrow"
                    />
                  </Button>
                )}
                <div className={`${props.isBundleSideBar ? 'bundletitle' : ''} `}>{props?.modalTitle}</div>
                {props.isPromotionCart && !showUpselling && !props.isBundleSideBar && (
                  <div className="promotionCartcard">For order amount above AED {props?.minCartAmount}</div>
                )}
                {props.isBundleSideBar && (
                  <div className="promotionCartca">
                    Add more items to the cart and get upto {props?.maxDiscount}% OFF!
                  </div>
                )}
                {modalSubTitle && <div className="sub-title">{modalSubTitle}</div>}
              </Modal.Title>
            </Modal.Header>
          )
        )}

        <Modal.Body
         className={`${props.bodyTextCenter && 'text-center'} ${props.bodyBg && 'whiteBg'} ${
          props?.isPromotionCart && props?.cartFillerLen < 7 ? 'promotionCartlen' : ''
        } 
        ${props?.isProductDetails && props?.isPromotionCart && props?.cartFillerLen < 7 ? 'fbtcartlen' : ''}
        ${props?.isPromotionCart && !props?.isBundleSideBar ? 'promotionCart' : ''} 
        ${props?.isPromotionCart && props?.isBundleSideBar ? 'bundleOfferBody' : ''} 
        ${fbt_isStock?.length > 0 || fbt_disabled ? 'promotionCart' : ''}${!props?.footerEnable ? 'fullHeight' : ''}`}
        >
          {props?.isPromotionCart && !props?.isBundleSideBar && !showUpselling && (
            <div
              className={`${props.isPromotionCart ? 'promotion' : ''}  ${
                props?.actionRequired === 'NO' ? 'noActionRequired' : ''
              } `}
            >
              <Image src={props?.actionRequired === 'NO' ? TAG_GREEN.src : TAG_BROWN.src} width={15} height={15} />

              <div
                className={`promotionText`}
                dangerouslySetInnerHTML={{
                  __html: props?.actionRequired === 'NO' ? `${props?.messagePrefix} ${props?.message}` : props?.message,
                }}
              />
            </div>
          )}

          {props.children}
        </Modal.Body>
        {props?.footerEnable && (
          <Modal.Footer
            className={`px-4 justify-content-${props?.footerAlignment} ${props?.footerBtnFullWidth && 'flex-nowrap'} ${
              props?.footerClassName
            }`}
          >
            {props?.secondaryButtonText && (
              <Button
                data-test="button1"
                className={props.footerBtnFullWidth && 'w-100 mx-auto py-3'}
                variant="secondary"
                onClick={() => {
                  setShow(false);
                  if (showCTA) props?.handleClose();
                  secondaryButtonClicked();
                }}
              >
                {props?.secondaryButtonText}
              </Button>
            )}
            {props?.dangerButtonText && (
              <Button className={props.footerBtnFullWidth && 'w-100 mx-auto py-3'} variant="danger">
                {props?.dangerButtonText}
              </Button>
            )}
            {props?.primaryButtonText && (
              <>
                {props.isshowUpselling ? (
                  <div className="customContainer">
                    <div className="price-wrapper">
                      <div className="qty">
                        {(fbtSkuId?.length > 1 && !fbt_disabled && !fbt_isStock?.length > 0) ||
                        (fbtshow3?.length === 2 && !fbt_disabled)
                          ? `${pdp_qty} Item(s)`
                          : `${upsellingqty} Item(s)`}
                      </div>
                      <div className="currency-label">
                        {(fbtSkuId?.length > 1 && !fbt_disabled && !fbt_isStock?.length > 0) ||
                        (fbtshow3?.length === 2 && !fbt_disabled)
                          ? `AED ${pdp_price}`
                          : `AED ${upsellingprice}`}
                      </div>
                    </div>
                    <div className="primaryButton-wrapper">
                      <Button
                        data-testid="primaryButton"
                        className={props.footerBtnFullWidth && 'w-100 mx-auto py-3'}
                        variant={props?.appVariant ? props?.appVariant : 'primary'}
                        size="sm"
                        onClick={primaryButtonClicked}
                        disabled={props?.isPrimaryButtonDisabled}
                      >
                        {props?.primaryButtonText}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <Button
                    data-testid="primaryButton"
                    className={props.footerBtnFullWidth && 'w-100 mx-auto py-3'}
                    variant={props?.appVariant ? props?.appVariant : 'primary'}
                    size="sm"
                    onClick={primaryButtonClicked}
                    disabled={props?.isPrimaryButtonDisabled}
                  >
                    {props?.primaryButtonText}
                  </Button>
                )}
              </>
            )}
              {props?.primaryButton && (
              <>
                {props.isBundleoffer ? (
                  <div className="customContainerbundle">
                    <div className="price-wrapper-bundle">
                      <div className="qty-bundle-bundle">{`${props?.quantity} Item(s)`}</div>
                      <div className="currency-label-bundle">{`AED ${props?.sellingPrice}`}</div>
                    </div>
                    <div className="primaryButton-wrapper-bundle">
                      <Button
                        data-testid="primaryButton"
                        className={props.footerBtnFullWidth && 'w-100 mx-auto py-3'}
                        variant={props?.appVariant ? props?.appVariant : 'primary'}
                        size="sm"
                        onClick={primaryButtonClicked}
                        disabled={props?.isPrimaryButtonDisabled}
                      >
                        {props?.primaryButton}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <Button
                    data-testid="primaryButton"
                    className={props.footerBtnFullWidth && 'w-100 mx-auto py-3'}
                    variant={props?.appVariant ? props?.appVariant : 'primary'}
                    size="sm"
                    onClick={primaryButtonClicked}
                    disabled={props?.isPrimaryButtonDisabled}
                  >
                    {props?.primaryButtonText}
                  </Button>
                )}
              </>
            )}
            {props?.customFooter && <>{props.customFooter}</>}
          </Modal.Footer>
        )}
      </Modal>
    </RightSideBarStyled>
  );
};

RightSideBar.propTypes = {
  children: PropTypes.any,
  messagePrefix: PropTypes.string,
  closeButton: PropTypes.bool,
  modalTitle: PropTypes.string,
  bodyTextCenter: PropTypes.bool,
  noFooter: PropTypes.bool,
  footerAlignment: PropTypes.string,
  footerBtnFullWidth: PropTypes.any,
  primaryButtonText: PropTypes.string,
  appVariant: PropTypes.string,
  dangerButtonText: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  size: PropTypes.string,
  customClass: PropTypes.string,
  handleClose: PropTypes.any,
  secondaryButtonClicked: PropTypes.any,
  primaryButtonClicked: PropTypes.any,
  backButtonClicked: PropTypes.any,
  isBackEnabled: PropTypes.bool,
  isProductDetails: PropTypes.bool,
  isPrimaryButtonDisabled: PropTypes.bool,
  bodyBg: PropTypes.bool,
  footerEnable: PropTypes.bool,
  isHide: PropTypes.bool,
  customFooter: PropTypes.any,
  arrowIconHeight: PropTypes.any,
  arrowIconWidth: PropTypes.any,
  orderType: PropTypes.string,
  footerClassName: PropTypes.string,
  isPromotionCart: PropTypes.bool,
  modalSubTitle: PropTypes.string,
};
RightSideBar.defaultProps = {
  children: '',
  messagePrefix: '',
  size: 'lg',
  closeButton: false,
  modalTitle: '',
  bodyTextCenter: false,
  noFooter: false,
  footerAlignment: 'center',
  footerBtnFullWidth: false,
  primaryButtonText: '',
  dangerButtonText: '',
  secondaryButtonText: '',
  customClass: '',
  isBackEnabled: false,
  handleClose: () => {},
  isPrimaryButtonDisabled: false,
  footerEnable: true,
  isHide: true,
  customFooter: null,
  arrowIconHeight: '15',
  arrowIconWidth: '40',
  orderType: 'Shipment',
  footerClassName: '',
  isPromotionCart: false,
  isProductDetails: false,
  modalSubTitle: '',
};
export default RightSideBar;
